export default "__VITE_ASSET__uKjFdXoP__"